// extracted by mini-css-extract-plugin
export default {"container":"TabMenu_container__KzbKt","active":"TabMenu_active__tmZiP"};